import React, { Fragment } from 'react'
import { Intro, Slideshow, slideTypes, slideTextTypes } from 'cvs-core'
import img1 from '../../assets/images/U1-T1-1a_R.svg'
import img2 from '../../assets/images/U1-T1-1b_L.svg'
import img3 from '../../assets/images/U1-T1-1c_U.svg'
import img4 from '../../assets/images/U1-T1-1d_R.svg'
import voAudio1 from '../../assets/vo/Setup-01.mp3'
import voAudio2 from '../../assets/vo/Setup-02.mp3'
import voAudio3 from '../../assets/vo/Setup-03.mp3'
import voAudio4 from '../../assets/vo/Setup-04.mp3'

const data = [
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 8,
    panDirection: 'right',
    image: img1,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Is vaping safe?',
    },
    vo: {
      sources: [
        {
          src: voAudio1,
        },
      ],
      transcript: (
        <span>
          Some people claim that vaping or using e-cigarettes is safer than
          smoking, but is it actually <em>safe</em>?
        </span>
      ),
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 5,
    panDirection: 'left',
    image: img2,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Nicotine is addictive.',
    },
    vo: {
      sources: [
        {
          src: voAudio2,
        },
      ],
      transcript: 'E-cigarettes contain nicotine, a highly addictive chemical.',
    },
  },
  {
    SlideType: slideTypes.VerticalPan,
    duration: 8.3,
    panDirection: 'up',
    image: img3,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Brain Damage',
    },
    vo: {
      sources: [
        {
          src: voAudio3,
        },
      ],
      transcript:
        'Vaping or using e-cigarettes can damage a developing brain and affect memory, concentration, and decision making.',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 10,
    panDirection: 'right',
    image: img4,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Responding to Peer Pressure',
    },
    vo: {
      sources: [
        {
          src: voAudio4,
        },
      ],
      transcript:
        'In this module, you will learn ways to help yourself and your friends stick to your choices about vaping or using e-cigarettes regardless of peer pressure.',
    },
  },
]

export default {
  title: 'Using e-Cigarettes',
  path: '/prepare/using-e-cigarettes',
  content: (
    <Fragment>
      <Intro
        title="Using e-Cigarettes"
        direction="Select the play button below to begin."
        // lead=""
        // img={image}
      />
      <Slideshow slides={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Setup.js